(function(){
  if (window.cxCardCarousel) return; window.cxCardCarousel = true;
  function go(figure, dir){
    if(!figure) return;
    var media = figure.querySelector('.cx-card-media'); if(!media) return;
    var slides = media.querySelectorAll('.product-card__image--primary, .cx-card-slide');
    var total = slides.length; if(total < 2) return;
    var cur = parseInt(media.getAttribute('data-cx-index') || '0', 10);
    var next = (cur + dir + total) % total;
    media.setAttribute('data-cx-index', next);
    slides.forEach(function(s, i){ s.classList.toggle('is-active', i === next); if (s.loading === 'lazy' && Math.abs(i - next) <= 1) s.loading = 'eager'; });
    media.classList.toggle('is-moved', next !== 0);
    figure.querySelectorAll('.cx-card-dots span').forEach(function(d, i){ d.classList.toggle('is-active', i === next); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.cx-card-arrow'); if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    go(btn.closest('.product-card__figure'), btn.classList.contains('cx-card-arrow--prev') ? -1 : 1);
  }, true);
})();
